import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { map, Observable } from "rxjs";
import { IssueModel } from "src/app/models/api/issue.model";
import { InventoryResourceGraph } from "src/app/models/api/inventoryResource.model";

@Injectable({
    providedIn: "root",
})
export class IssuesDataService {
    constructor(private _http: HttpClient) {}

    public getIssuesData(): Observable<IssueModel[]> {
        return this._http.get<IssueModel[]>("assets/mockData/issuesMockData.json");
    }

    public getIssueByID(issueId: string): Observable<IssueModel> {
        return this._http.get<IssueModel[]>(`assets/mockData/issuesMockData.json`).pipe(
            map((issues: IssueModel[]) => {
                const issue = issues.find((issue) => issue.id === issueId);
                if (!issue) {
                    throw new Error(`Issue with id ${issueId} not found`);
                }
                return issue;
            }),
        );
    }

    public getIssueRelationsGraph(issueId: string): Observable<InventoryResourceGraph> {
        return this._http.get<{ issueId: string; graphData: InventoryResourceGraph }[]>("assets/mockData/issueGraphMockData.json").pipe(
            map((data: { issueId: string; graphData: InventoryResourceGraph }[]) => {
                const issueData = data.find((item) => item.issueId === issueId);
                if (!issueData) {
                    throw new Error(`Graph data for issue with id ${issueId} not found`);
                }
                const graphData = issueData.graphData;

                if (Array.isArray(graphData.graphNodes) && graphData.graphNodes.length > 0) {
                    graphData.graphNodes[0].resource = {
                        ...graphData.graphNodes[0].resource,
                        id: issueId,
                    };
                }
                return graphData;
            }),
        );
    }
}
